import { SiafLiteApiRepository, SiafLiteApiStream } from "../../external";
import store from "../../config/store";

class OrdemServicoService {
  constructor() {
    this.urlBase = "faturamento/ordem-servicos";
    this.urlBaseEvent = `/event/${this.urlBase}`;
    this.urlBaseCompleta = `${store.baseUrl}/${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  reabrir(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).putBase(
      `/reabrir/${id}`,
    );
  }

  cancelar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).putBase(
      `/cancelar/${id}`,
    );
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  atualizarStatus(id, body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/update-status`).put(
      id,
      body,
    );
  }

  getOS(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/ordem-servico`,
    ).patch(body);
  }

  getTermoAceiteChecklist(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/termo-aceite-checklist`,
    ).patch(body);
  }

  getModeloRecibo80mm(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/recibo`).patch(body);
  }

  getRelatorioResumido(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/resumido`,
    ).path(body);
  }

  getRelatorioDetalhado(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/detalhado`,
    ).path(body);
  }

  getRelatorioComissaoPrestadores(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/comissao-prestadores`,
    ).path(body);
  }

  getRelatorioServicosVendidos(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/servicos-vendidos`,
    ).path(body);
  }

  getRelatorioAnaliseAbcServicos(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/analise-abc-servicos`,
    ).path(body);
  }

  gerarPdf(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/ordem-servico-pdf`,
    ).path(body);
  }

  getRelatorioDashboardKpis(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-kpis`,
    ).patch(body);
  }

  getRelatorioDashboardFluxo(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-fluxo`,
    ).patch(body);
  }

  getRelatorioDashboardEvolucao(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-evolucao`,
    ).patch(body);
  }

  getRelatorioDashboardProdutividade(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-produtividade`,
    ).patch(body);
  }

  getRelatorioDashboardClientes(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-clientes`,
    ).patch(body);
  }

  getRelatorioDashboardVendas(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-vendas`,
    ).patch(body);
  }

  getRelatorioDashboardAtencao(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-atencao`,
    ).patch(body);
  }

  getRelatorioDashboardSatisfacao(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-satisfacao`,
    ).patch(body);
  }

  getRelatorioDashboardPrazosGargalos(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-prazos-gargalos`,
    ).patch(body);
  }

  getRelatorioDashboardListagemStatus(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-listagem-status`,
    ).patch(body);
  }
}

export default OrdemServicoService;
